<app-spinner [show]="showSpinner"></app-spinner>
<!-- Start Register Area -->
<section class="register-area">
    <div class="row m-0">
        <div class="col-lg-6 col-md-12 p-0">
            <div class="register-image">
                <img src="assets/img/register-bg.jpg" alt="image">
            </div>
        </div>

        <div class="col-lg-6 col-md-12 p-0">
            <div class="register-content">
                <div class="d-table">
                    <div class="d-table-cell">
                        <div class="register-form">
                            <!-- <div class="logo">
                                <a href="index.html"><img src="assets/img/black-logo.png" alt="image"></a>
                            </div> -->

                            <h3>Require Information</h3>

                            <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                                <div class="form-group">
                                    <input type="text" placeholder="{{nameText}}" class="form-control" formControlName="name">
                                    <div *ngIf="name.invalid && (name.dirty || name.touched)"
                                        class="alert alert-danger">
                                        <div *ngIf="name.errors.required">
                                            Name is required.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <select #selectSex class="form-control" controlName="sex">
                                        <option value="">{{sexText}}</option>
                                        <option value="1">{{male}}</option>
                                        <option value="2">{{female}}</option>
                                    </select>
                                </div>

                                <div class="form-group">

                                    <input placeholder="{{dobText}}" class="dob" type="date"
                                 id="date" formControlName="dob" value="">

                                 
                                </div>


                                <div class="form-group">
                                    <input type="text" placeholder="{{phoneText}}" [ngClass]="{'disabled-button':phoneValue}" class="form-control"
                                        formControlName="phoneNumber" (keypress)=onKeyPressEvent($event)>
                                    <div *ngIf="phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)"
                                        class="alert alert-danger">

                                        <div *ngIf="phoneNumber.errors.required">
                                            Phone is required.
                                        </div>
                                        <div *ngIf="phoneNumber.errors.minlength || phoneNumber.errors.maxlength">
                                            Invalid Phone.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group inputcontainer">
                                        <input type="email" [ngClass]="{'disabled-button':emailValue}" placeholder="{{emailForLogin}}"
                                            class="form-control is-loading is-loading-sm" formControlName="email"
                                            (keyup)="onEmailTextFieldKeyUp($event)">
                                        <div *ngIf="isCheckingUser" class="icon-container">
                                            <i class="loader"></i>
                                        </div>
                                        <div *ngIf="email.invalid && (email.dirty || email.touched);else elseBlock"
                                            class="alert alert-danger">
    
                                            <div *ngIf="email.errors.required">
                                                Email is required.
                                            </div>
                                            <div *ngIf="email.invalid && !email.errors.required">
                                                Invalid email.
                                            </div>
                                        </div>
                                        <ng-template #elseBlock>
                                            <div class="alert alert-danger" *ngIf="isUserExist">Duplicated Email Address
                                            </div>
                                        </ng-template>
    
                                    </div>

                                <button type="submit"
                                    [ngClass]="{'disabled-button':registerForm.invalid || isUserExist}">Submit</button>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Register Area -->
